import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Pages.css';

function InternalAuditing() {
  const { t } = useTranslation();

  return (
    <div className="main-bg">
      <Header />
      <div className="page-container">
        <div className="page-header">
          <h1>{t('services.service2.title')}</h1>
          <div className="page-bar"></div>
        </div>
        
        <div className="page-content">
          <div className="service-detail">
            <div className="service-description">
              <h2>Përshkrimi i Shërbimit</h2>
              <p>{t('services.service2.desc')}</p>
              <p>Shërbimi ynë i auditimit të brendshëm përfshin:</p>
              <ul>
                <li>Vlerësimi i efektivitetit të kontrollit të brendshëm</li>
                <li>Identifikimi i rreziqeve dhe vulnerabiliteteve</li>
                <li>Përmirësimi i proceseve të biznesit</li>
                <li>Sigurimi i përputhshmërisë me rregulloret</li>
                <li>Raportimi dhe rekomandimet për përmirësim</li>
              </ul>
            </div>
            
            <div className="service-benefits">
              <h2>Përfitimet</h2>
              <div className="benefits-grid">
                <div className="benefit-card">
                  <h3>Transparencë e Rritur</h3>
                  <p>Identifikimi i problemeve para se të bëhen kritike</p>
                </div>
                <div className="benefit-card">
                  <h3>Menaxhim i Rrezikut</h3>
                  <p>Strategji për minimizimin e rreziqeve</p>
                </div>
                <div className="benefit-card">
                  <h3>Përmirësimi i Efikasitetit</h3>
                  <p>Optimizimi i proceseve të brendshme</p>
                </div>
                <div className="benefit-card">
                  <h3>Përputhshmëri</h3>
                  <p>Sigurimi i përputhshmërisë me standardet</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default InternalAuditing; 